export enum Period {
  DAYS_1 = '1d',
  DAYS_7 = '7d',
  MONTH_1 = '1mo',
  THIS_WEEK = 'this_week',
  PAST_WEEK = 'past_week',
  THIS_MONTH = 'this_month',
  PAST_MONTH = 'past_month',
}
